module.exports = __webpack_public_path__ + "static/media/067-no battery.a92733c8.svg";